import React, { useRef, useState } from 'react';
import PageHeader from 'layout/components/PageHeader';
import PageContainer from 'layout/components/PageContainer';
import AppUserRatingsTable from '../components/AppUserRatingsTable';
import AppUserRatingsStatsPanel from '../components/AppUserRatingsStatsPanel';
import { useAppUserRatings, getDefaultFilters } from '../hook/useAppUserRatings';
import { createTableScrollHandler } from 'utils/tableUtils';
import { Divider, Drawer } from '@material-ui/core';
import AppUserRatingsFilters from '../components/AppUserRatingsFilters';
import AppUserRatingsChipsBar from '../components/AppUserRatingsChipsBar';
import RefreshList from 'shared/components/Table/Refresh';
import FiltersButton from 'shared/components/Table/FiltersButton';
import TableToolbar from 'shared/components/Table/TableToolbar';
import CloseFiltersButton from 'shared/components/Table/CloseFiltersButton';
import TrashAllFilters from 'shared/components/filters/TrashAllFilters';

const AppUserRatings = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [showFilters, setShowFilters] = useState(false);

  const {
    ratings,
    totalItems,
    page,
    rowsPerPage,
    filters,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSortChange,
    onFiltersChange,
    resetFilters,
    reload,
    loading
  } = useAppUserRatings();

  return (
    <div ref={tableRef}>
      <PageHeader
        area="Estadísticas - Calificación de Usuarios APP"
        title="Calificación de Usuarios APP"
        subArea="Tabla de calificaciones"
      />
      <div
        className="sticky top-0 right-0 left-0 flex flex-col"
        style={{ zIndex: 101, background: '#EAEDF5', marginBottom: '-24px' }}
      >
        <div className="flex w-full px-8 mt-2">
          <TableToolbar
            chips={
              <AppUserRatingsChipsBar
                filters={filters}
                defaultFilters={getDefaultFilters()}
                onFiltersChange={onFiltersChange}
              />
            }
            actions={
              <>
                <RefreshList onRefreshTable={() => reload()} isRefreshing={loading} />
                <FiltersButton onClick={() => setShowFilters(true)} isActive={showFilters} />
              </>
            }
          />
        </div>
      </div>
      <PageContainer lessMargin>
        <AppUserRatingsTable
          ratings={ratings}
          totalItems={totalItems}
          page={page}
          rowsPerPage={rowsPerPage}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          onSortChange={handleSortChange}
          handlePageChange={createTableScrollHandler(tableRef)}
        />
      </PageContainer>
      <AppUserRatingsStatsPanel filters={filters} onFiltersChange={onFiltersChange} />
      <Drawer
        variant="persistent"
        anchor="right"
        open={showFilters}
        className="max-w-md"
        transitionDuration={300}
      >
        <div className="flex flex-col h-full">
          <div
            className="flex justify-between items-center px-2"
            style={{ backgroundColor: '#00163B' }}
          >
            <CloseFiltersButton
              onCloseFilters={() => setShowFilters(false)}
              inOpen={showFilters}
            />
            <TrashAllFilters onClick={resetFilters} />
          </div>
          <Divider />
          <AppUserRatingsFilters
            onSubmit={(values) => {
              onFiltersChange(values);
              setShowFilters(false);
            }}
            initialValues={filters}
          />
        </div>
      </Drawer>
    </div>
  );
};

export default AppUserRatings;
